<template>
  <v-main>
    <ColorPickerDialog ref="colorPickerDialog" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      :selectable="true"
      @update:selected="(v) => (selectedIds = v)"
      @rowClicked="go"
    >
      <!-- <template v-slot:sidebar-extra="{ selected }">
        <v-btn color="primary">Nova Org...</v-btn>
        <v-btn>Adicionar Tag...</v-btn>
        <v-btn>Remover Tag...</v-btn>
        <v-btn>Definir Cor...</v-btn>
        <v-spacer />
        <OMenuButton :menuOpts="computeMenuOpts(selected)" />
      </template> -->

      <template v-slot:topbar-actions>
        <v-spacer />
        <OMenuButton :menuOpts="menuOpts" />
      </template>
    </GenericReport>
  </v-main>
  <!-- <v-content>
    <v-toolbar class="card-bar">
      <v-toolbar-title>Organizações</v-toolbar-title>

      <v-btn icon @click="reload" class="ml-5">
        <v-icon>refresh</v-icon>
      </v-btn>

      <OSelectColsButton class="mx-2" :fullSpec="fullSpec" v-model="vars" />

      <v-spacer />

      <v-text-field
        v-model="keywords"
        placeholder="Palavras-chave..."
        single-line
        hide-details
        append-icon="mdi-magnify"
      />

      <v-spacer />

      <v-switch
        v-model="onlyPrd"
        label="Apenas PRD"
        hide-details
        class="pa-0 ml-5"
      />

      <v-spacer />

      <OMenuButton :menuOpts="menuOpts" btnClass="ml-2" />
    </v-toolbar>

    <OLoadingLine absolute :value="isLoading" />

    <ColorPickerDialog ref="colorPickerDialog" />

    <div class="maxh-2bar">
      <ODataTable
        :spec="spec"
        :items="filteredRows"
        @rowClicked="go"
        :selectable="true"
        :fullRowSelectable="false"
        :selected="selectedIds"
      />
    </div>
  </v-content> -->
</template>

<script>
// import _ from 'lodash'
import { Org } from '@/models'
import {
  hasTag,
  isEmpty,
  ensureTags,
  withoutTags,
  matchAnyLike
} from 'oderon-commons/src/utils'
// import { selectCols } from 'oderon-commons/src/tables'
// import { savePref, getPref } from 'oderon-vue/Prefs'
import { /*defCodes,*/ fullSpec } from './org-columns'
// import ODataTable from 'oderon-vue/cpts/ODataTable.vue'
// import OSelectColsButton from 'oderon-vue/cpts/OSelectColsButton.vue'
import ColorPickerDialog from './ColorPickerDialog.vue'

import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import OMenuButton from 'oderon-vue/cpts/OMenuButton.vue'

// const _key = 'oderonAdminOrgCols'

export default {
  pageTitle: 'Organizações',
  components: {
    GenericReport,
    // ODataTable,
    // OSelectColsButton,
    ColorPickerDialog,
    OMenuButton
  },
  data() {
    return {
      // isLoading: false,
      // onlyPrd: true,
      // keywords: null,
      // rows: [],

      // fullSpec,
      // vars: getPref(_key, defCodes),

      selectedIds: [],

      reportSpec: {
        code: 'orgs',
        title: 'Organizações',
        apiBase: '/organizations',
        paging: 'countOnly',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'onlyPrd',
            label: 'Apenas PRD',
            defVal: true
          }
        ]
      },

      adapterSpec: fullSpec
    }
  },
  computed: {
    menuOpts() {
      let len = this.selectedIds.length || 0
      return [
        {
          text: 'Nova Org...',
          onClick: () => this.newOrg()
        },
        { isDivider: true },
        {
          text: 'Adicionar Tag...',
          onClick: () => this.addTag(),
          disabled: len < 1
        },
        {
          text: 'Remover Tag...',
          onClick: () => this.removeTag(),
          disabled: len < 1
        },
        {
          text: 'Definir Cor...',
          onClick: () => this.setColor(),
          disabled: len < 1
        },
        { isDivider: true },
        {
          text: 'Exportar CSV',
          onClick: () => this.$refs.report.checkDownload()
        }
      ]
    }
    // spec() {
    //   return selectCols(this.fullSpec, this.vars)
    // },

    // filteredRows() {
    //   return this.rows.filter((r) => {
    //     let ei = r.extraInfo || {}
    //     if (this.onlyPrd && !hasTag(ei.tags, 'PRD')) return false
    //     if (
    //       !isEmpty(this.keywords) &&
    //       !matchAnyLike(
    //         this.keywords,
    //         r.id,
    //         r.name,
    //         r.label,
    //         ei.tags,
    //         ei.comments
    //       )
    //     )
    //       return false
    //     return true
    //   })
    // },

    // },
    // mounted() {
    //   this.reload()
    // },

    // watch: {
    //   vars() {
    //     savePref(_key, this.vars)
    //   }
  },
  methods: {
    // reload() {
    //   this.$loading(this.fetchData())
    // },

    async fetchData(apiParams) {
      let rows = await Org.findAll()
      // rows.forEach((r) => {
      //   if (r.extraInfo == null) r.extraInfo = {}
      // })

      let { onlyPrd, keywords } = apiParams
      rows = rows.filter((r) => {
        let ei = r.extraInfo || {}
        if (onlyPrd && !hasTag(ei.tags, 'PRD')) return false
        return matchAnyLike(
          keywords,
          r.id,
          r.name,
          r.label,
          ei.tags,
          ei.comments
        )
      })

      return { rows, count: null }
    },

    async newOrg() {
      let name = await this.$prompt({
        label: 'Informe o nome (código) da nova org:'
      })

      if (name == null) return

      await this.$loading(async () => {
        await Org.save({
          name,
          url: `https://${name}.oderon.com.br`,
          useQueue: true,
          extraInfo: {}
        })
      })

      this.$router.push(`/orgs/${name}`)
    },

    go({ row, isMiddle }) {
      if (isMiddle) {
        window.open(`/#/orgs/${row.id}`, '_blank')
      } else {
        this.$router.push(`/orgs/${row.id}`)
      }
    },

    async doOnSelectedOrgs(fn) {
      await this.$loading(async () => {
        for (let id of this.selectedIds) {
          let org = await Org.findById(id)
          if (org.extraInfo == null) org.extraInfo = {}
          await fn(org)
        }

        await this.$refs.report.reload()
      })
    },

    async addTag() {
      let tag = await this.$prompt({
        label: 'Informe a tag a ser adicionada:'
      })

      if (!isEmpty(tag)) {
        await this.doOnSelectedOrgs(async (org) => {
          ensureTags(org.extraInfo, tag)
          await Org.patch(org.id, { extraInfo: org.extraInfo })
        })
      }
    },

    async removeTag() {
      let tag = await this.$prompt({
        label: 'Informe a tag a ser removida:'
      })

      if (!isEmpty(tag)) {
        await this.doOnSelectedOrgs(async (org) => {
          org.extraInfo.tags = withoutTags(org.extraInfo.tags, tag)
          await Org.patch(org.id, { extraInfo: org.extraInfo })
        })
      }
    },

    async setColor() {
      let color = await this.$refs.colorPickerDialog.open()
      if (color != null) {
        await this.doOnSelectedOrgs(async (org) => {
          await Org.patch(org.id, { color })
        })
      }
    }
  }
}
</script>

<style></style>
